// extracted by mini-css-extract-plugin
export default {"container":"sTlNeKncT29xGMEsD29T"};